module.exports = __webpack_public_path__ + "static/img/LOGO.9bb39348.png";